import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-previousPage",
  "use": "icon-previousPage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-previousPage\"><defs><style type=\"text/css\"></style></defs><path d=\"M532.48 51.2a65.152 65.152 0 0 1 0 92.16L163.84 512l368.64 368.64c24.4224 24.4224 25.3952 63.4112 2.9184 89.0112l-2.9184 3.1232a65.152 65.152 0 0 1-92.16 0L25.6 558.08A65.152 65.152 0 0 1 25.6 465.92L440.32 51.19999999a65.152 65.152 0 0 1 92.16 1e-8z\" p-id=\"1647\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol